import { useMemo, useState } from "react";
import { hdmgdjRankingCategories, hdmgdjRankingList } from "@/mocks/hdmgdj/ranking";

export default function HdmgdjRanking() {
  const [active, setActive] = useState("all");

  const list = useMemo(
    () =>
      (active === "all"
        ? hdmgdjRankingList
        : hdmgdjRankingList.filter((item) => item.category === active)
      ).slice(0, 6),
    [active]
  );

  return (
    <section id="hdmgdj-ranking" className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="hdmgdj-container">
        <div className="grid grid-cols-1 lg:grid-cols-[0.82fr_1.18fr] gap-10 lg:gap-14">
          <div className="hdmgdj-reveal">
            <span className="inline-flex items-center gap-2 text-primary-300 text-[14px] font-label font-bold">
              <i className="ri-trophy-line text-lg" />
              魔改热榜
            </span>
            <h2 className="mt-3 font-heading text-background-50 text-[30px] md:text-[44px] leading-tight">
              大家正在追的
              <br />
              <span className="text-primary-500">魔改短剧</span>
            </h2>
            <p className="mt-5 text-[15px] leading-8 text-background-200">
              榜单每小时同步站内热度，投票越多、催更越猛的作品，更新得越快。挑一个方向，看看此刻大家在追什么。
            </p>

            <div className="mt-7 flex flex-wrap gap-2.5">
              {hdmgdjRankingCategories.map((cat) => {
                const on = active === cat.id;
                return (
                  <button
                    key={cat.id}
                    type="button"
                    onClick={() => setActive(cat.id)}
                    aria-pressed={on}
                    className={`h-9 px-4 rounded-full text-[13px] font-label whitespace-nowrap transition-colors cursor-pointer border ${
                      on
                        ? "bg-primary-500 border-primary-500 text-foreground-950 font-bold"
                        : "bg-background-50/[0.06] border-background-50/15 text-background-200 hover:border-primary-500/50 hover:text-primary-300"
                    }`}
                  >
                    {cat.name}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="hdmgdj-reveal">
            <div className="flex items-center justify-between pb-3 border-b border-background-50/12">
              <p className="text-[13px] font-label text-background-200/70">
                {active === "all" ? "全部方向" : hdmgdjRankingCategories.find((c) => c.id === active)?.name}
                <span className="ml-2 text-background-200/40">· 实时热度</span>
              </p>
              <span className="text-[12px] font-label text-background-200/50">每小时更新</span>
            </div>

            <ul className="mt-2">
              {list.map((item) => (
                <li
                  key={item.id}
                  className="group flex items-center gap-4 py-3.5 border-b border-background-50/8"
                >
                  <span
                    className={`w-6 text-center font-heading text-[18px] shrink-0 ${
                      item.rank <= 3 ? "text-primary-500" : "text-background-200/40"
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="w-11 h-14 rounded-md overflow-hidden bg-foreground-900 shrink-0">
                    <img
                      src={item.cover}
                      alt={`黄豆魔改短剧-${item.title}`}
                      title={`黄豆魔改短剧-${item.title}`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-[15px] font-bold font-label text-background-50 truncate">
                      {item.title}
                    </p>
                    <div className="mt-1.5 flex items-center gap-2">
                      <span className="text-[11px] font-label text-primary-300/90 px-2 h-5 inline-flex items-center rounded bg-primary-500/12">
                        {item.categoryName}
                      </span>
                      <span className="text-[11px] font-label text-background-200/50">{item.tag}</span>
                    </div>
                  </div>
                  <span className="inline-flex items-center gap-1 text-[13px] font-label text-accent-400 shrink-0">
                    <i className="ri-fire-fill text-base" />
                    {item.heat}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}